import {
  Card,
  Tag,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Typography,
} from '@growdash/design-system/atoms';
import { Info, TrendingDown, TrendingUp } from 'lucide-react';

type Props = {
  unit?: string;
  value: string | number;
  title: string;
  className?: string;
  toolTipInfo?: string;
  valueDifference?: number;
  percentageDifference?: number;
};

export default function OverviewCard({
  unit = '',
  value,
  title,
  className = '',
  toolTipInfo,
  valueDifference,
  percentageDifference,
}: Props) {
  return (
    <Card className={`${className} p-4`}>
      <div className="flex items-center gap-2 max-h-[1.3125rem]">
        <Typography className="font-semibold">{title}</Typography>
        {toolTipInfo?.length ? (
          <TooltipProvider>
            <Tooltip delayDuration={0}>
              <TooltipTrigger>
                <div className="w-3 h-3 rounded-full flex justify-center">
                  <Info className="fill-bg_secondary w-full h-full [&>circle]:stroke-bg_secondary stroke-background text-bg_background" />
                </div>
                <TooltipContent>{toolTipInfo}</TooltipContent>
              </TooltipTrigger>
            </Tooltip>
          </TooltipProvider>
        ) : null}
      </div>

      <Typography className="my-4 font-bold text-2xl text-content">
        {value}
        {unit ?? ''}
      </Typography>
      <div className="flex items-center gap-1">
        {percentageDifference ? (
          <Tag>
            {percentageDifference > 0 ? (
              <div className="flex gap-1 items-center">
                <TrendingUp className="w-3 h-3" />
                <span>{`+${percentageDifference}%`}</span>
              </div>
            ) : (
              <div className="flex gap-1 items-center">
                <TrendingDown className="w-3 h-3" />
                {percentageDifference}%
              </div>
            )}
          </Tag>
        ) : null}
        {valueDifference ? (
          <Tag>
            {valueDifference > 0 ? '+' : ''}
            {valueDifference}
          </Tag>
        ) : null}
      </div>
      <Typography className="mt-1 text-tertiary font-medium text-[0.5625rem]">
        Last month
      </Typography>
    </Card>
  );
}
